<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg5>
          <v-card class="elevation-2" v-if="quoteData">
            <v-img
                class="white--text pb-2"
                style="background:linear-gradient(135deg, #0badeb 0%,#0470dc 100%);"
                height="100px">
              <v-card-title class="display-1 pt-6 pb-0 font-light white--text" >
                $<div v-if="!quoteLoading"> {{totalListCost}}</div>
                <v-progress-circular
                    v-else
                    indeterminate
                    color="white"
                ></v-progress-circular>
              </v-card-title>
<!--              <v-card-title class="pt-2">Estimate</v-card-title>-->
              <v-card-subtitle class="subtitle-1 pt-2 pb-3" v-if="quoteId">Order ID: {{quoteId.slice(0,8)}}</v-card-subtitle>

            </v-img>
            <v-tabs
                v-model="tab"
                centered>
<!--                  <v-tabs-slider style="background-color: #023765"></v-tabs-slider>-->
              <v-tabs-slider style="background:linear-gradient(135deg, #0badeb 0%,#0470dc 100%);"></v-tabs-slider>
                  <v-tab
                      v-for="item in tabItems"
                      :key="item"
                  >
                    {{ item }}
                  </v-tab>
                </v-tabs>
            <v-tabs-items v-model="tab">
<!--date and time-->
              <v-tab-item>
<!--                <div class="align-center">Pick a time and date of service. </div>-->
                <v-container>
                  <v-card flat>
                    <v-card-text>
                      <div class="subtitle-1">Select preferred time and date of service</div>
                      <v-divider></v-divider>
                      <date-time-picker
                          :orderTime="time"
                          :orderDate="date"
                          @dateFound="datePicked"
                          @timeFound="timePicked"
                      ></date-time-picker>
                    </v-card-text>
                  </v-card>
                </v-container>

              </v-tab-item>
<!--locations-->
              <v-tab-item>
                <v-container fluid fill-height>
                  <v-layout align-center justify-center>
                    <v-col>
                      <v-flex xs12 sm12 md12>
                       <v-card flat>
                         <v-card-text>
                           <div class="subtitle-1">View and edit location details</div>
                           <v-divider></v-divider>
                         </v-card-text>
                       </v-card>
                        <v-simple-table
                            fixed-header
                        >
                          <template v-slot:default>
                            <thead>
                            <tr>
                              <th class="text-left">
                                <v-icon class="red--text">pin_drop</v-icon>
                              </th>
                              <th class="text-left">
                                Locations
                              </th>
                              <th class="text-right">
                                Edit
                              </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="(location, index) in quoteData.locations" :key="location.id"

                            >
                              <td>{{index+1}}</td>
                              <td  @click="changeLabel(location.id)">
                                <v-icon v-if="location.label" class="yellow--text">label</v-icon>
                                {{ locationCountryRemoved(location.formatted_address)}}
                              </td>
                              <td class="text-right">
<!--             Location options drop down menu-->
                                <v-menu bottom left>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                        icon
                                        v-on="on"
                                    >
                                      <v-icon>more_vert</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <v-list-item @click="moveLocationUp(location.id)" >
                                      <v-list-item-action>
                                        <v-icon class="black--text">arrow_upward</v-icon>
                                      </v-list-item-action>
                                      <v-list-item-title>Move Up</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="moveLocationDown(location.id)">
                                      <v-list-item-action>
                                        <v-icon class="black--text">arrow_downward</v-icon>
                                      </v-list-item-action>
                                      <v-list-item-title>Move down</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="changeLabel(location.id)">
                                      <v-list-item-action>
                                        <v-icon class="black--text">label</v-icon>
                                      </v-list-item-action>
                                      <v-list-item-title>Add note</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="removeLocation(location.id)">
                                      <v-list-item-action>
                                        <v-icon class="red--text">clear</v-icon>
                                      </v-list-item-action>
                                      <v-list-item-title>Remove</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </td>
                            </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-flex>
                    </v-col>
                  </v-layout>
                </v-container>
              </v-tab-item>
<!--items-->
              <v-tab-item>
                <v-card>
                  <v-card-text v-if="quoteData">
                    <v-container>
                      <v-row dense v-if="quoteData">
                        <v-col cols="12">
                          <v-card
                              class="mx-auto mb-2"
                              max-width="350"
                              flat
                          >
                            <div class="subtitle-1">Review and confirm order</div>
                            <v-divider></v-divider>
                          </v-card>
                        </v-col>
                        <!--Line items -->
                        <v-col cols="12"
                               v-for="lineItem in quoteData.lineItems"
                               :key="lineItem.id">
                          <v-card
                              class="mx-auto"
                              max-width="344"
                              @click="openItemDialog(lineItem)"
                          >
                            <v-list-item three-line>
                              <v-list-item-content>
                                <v-list-item-subtitle class="font-weight-bold subtitle-1">
                                  <div>
                                    {{ lineItem.title }}
                                  </div>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-if="lineItem.itemType === 'product'">
                                  Qty: {{lineItem.qty}}
                                </v-list-item-subtitle>
                                <div class="font-weight-medium">
                                  ${{Number(lineItem.cost).toFixed(2)}}
                                </div>
                              </v-list-item-content>
                              <v-list-item-avatar
                                  tile
                                  size="80"
                              >
                                <v-img :src="lineItem.imgs[0].url"></v-img>
                              </v-list-item-avatar>
                            </v-list-item>
                            <v-divider></v-divider>
<!--                            subline items-->
                            <v-simple-table>
                              <template v-slot:default>
                                <tbody v-if="lineItem.sublineItems">
                                <tr
                                    v-for="sublineItem in lineItem.sublineItems"
                                    :key="sublineItem.id"
                                >
                                  <td>{{sublineItem.title}}</td>
                                  <td>${{Number(sublineItem.cost * sublineItem.qty).toFixed(2)}}</td>
                                </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                            <v-divider></v-divider>
                            <v-card-actions class="font-weight-medium">
                              Subtotal: ${{calcLineItemCost(lineItem)}}

                            </v-card-actions>
                            <v-card-actions>
                              <div v-if="lineItem.availableOnDemand">
                                <v-icon small class="success--text">fiber_manual_record</v-icon>Available</div>
                              <div v-else><v-icon small class="warning--text">fiber_manual_record</v-icon>Needs confirmation</div>
                              <v-spacer></v-spacer>
                              <v-btn @click="openItemDialog(lineItem)"
                                     x-small
                                     rounded
                                     outlined
                              >edit</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                        <!--Payments-->
                        <v-col cols="12">
                          <v-card class="mx-auto mb-2"
                                  max-width="350" flat>
                            <v-card-actions>
                              <div class="subtitle-1 font-weight-regular">Total:</div>
                              <v-spacer></v-spacer>
                              <div class="subtitle-1 font-weight-regular">${{totalListCost}}</div>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-card class="mx-auto mb-2"
                                  max-width="350" flat>
                            <v-card-text>
                              <div class="subtitle-1">Payments</div>
                              <v-divider></v-divider>
                              <v-simple-table class="align-center"
                                              v-if="depositConfig" >
                                <template v-slot:default>
                                  <tbody  v-if="paymentStructure.combinedPayments.length !== 0" >
                                  <tr
                                      v-for="item in paymentStructure.combinedPayments"
                                      :key="item.id"
                                  >
                                    <td>{{ item.splitTitle }}</td>
                                    <td>${{item.splitAmount}}</td>
                                    <td v-if="item.status"> {{item.status}}</td>
                                  </tr>
                                  <tr>
                                  </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-card-text>
                          </v-card>
                        </v-col>

                        <v-col cols="12">
                          <!--    Accepted Payment methods-->
                          <v-card
                              class="mx-auto mb-2"
                              max-width="350"
                              v-if="convertableToBook"
                              flat>
                            <v-card-text class="mb-4" v-if="orderData">
                              <h4 v-if="orderData.paymentDueNow" class="subtitle-1 font-weight-bold mb-4" >
                                Due Now: $ {{orderData.paymentDueNow.splitAmount}}
                              </h4>
                              <v-row v-if="orderData.acceptedPaymentMethods" justify="center">
                                <v-expansion-panels  v-if="orderData.acceptedPaymentMethods.length > 1" multiple inset>
                                  <v-expansion-panel
                                      v-for="payment in orderData.acceptedPaymentMethods"
                                      :key="payment.id"
                                  >
                                    <v-expansion-panel-header>
                                      <v-img contain :src="payment.thumbNailImg" max-height="75" max-width="150"></v-img>{{payment.paymentMethod}}
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-img contain :src="payment.imageUrl" max-height="250" max-width="250"></v-img>
                                      {{payment.description}}
                                      <v-list v-if="payment.paymentMethod === 'E-transfer'">

                                        <v-card-actions v-if="tab === 2" class="mt-6">
                                          <v-btn block class="blue" v-if="!quoteRequestId"  dark @click="requestBookingConfirmation">

                                            Request booking</v-btn>
                                          <v-btn block text class="green--text" v-if="quoteRequestId">
                                            <v-icon class="green--text">check_circle</v-icon>
                                            Request Successful</v-btn>
                                        </v-card-actions>
<!--                                        <v-alert-->
<!--                                            dense-->
<!--                                            text-->
<!--                                            type="success"-->
<!--                                            v-model="emailCopied"-->
<!--                                        >-->
<!--                                          Email Copied!-->
<!--                                        </v-alert>-->
<!--                                        <v-btn class="mb-3 blue&#45;&#45;text" @click="copyEmail" block outlined>Copy email</v-btn>-->
                                        <!--                          <v-btn class="mb-6 green--text" @click="sendConfirmationText" block outlined>confirm transfer</v-btn>-->
                                      </v-list>
                                      <v-list v-if="payment.paymentMethod === 'Credit'">
                                        <v-btn class="mb-3 blue white--text" @click="routeToCardProcessing" block>Add payment method</v-btn>
                                      </v-list>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </v-expansion-panels>
                                <v-list v-else>
                                  <v-list-item>
                                    <v-img contain :src="orderData.acceptedPaymentMethods[0].thumbNailImg" max-height="75" max-width="150"></v-img>
                                    <v-list-item-content>
                                      <v-list-item-title>{{orderData.acceptedPaymentMethods[0].paymentMethod}}</v-list-item-title>
                                    </v-list-item-content>

                                  </v-list-item>
                                  <v-list-item>
                                    <v-list-item-content>
                                      {{orderData.acceptedPaymentMethods[0].description}}
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list v-if="orderData.acceptedPaymentMethods[0].paymentMethod === 'E-transfer'">
                                    <v-card-actions v-if="tab === 2" class="mt-6">
                                      <v-btn block class="blue" v-if="!quoteRequestId"  dark @click="requestBookingConfirmation">

                                        Request booking</v-btn>
                                      <v-btn block text class="green--text" v-if="quoteRequestId">
                                        <v-icon class="green--text">check_circle</v-icon>
                                        Request Successful</v-btn>
                                    </v-card-actions>
<!--                                    <v-alert-->
<!--                                        dense-->
<!--                                        text-->
<!--                                        type="success"-->
<!--                                        v-model="emailCopied"-->
<!--                                    >-->
<!--                                      Email Copied!-->
<!--                                    </v-alert>-->
<!--                                    <v-btn class="mb-3 blue&#45;&#45;text" @click="copyEmail" block outlined>Copy email</v-btn>-->
                                    <!--                      <v-btn class="mb-6 green--text" @click="sendConfirmationText" block outlined>confirm transfer</v-btn>-->
                                  </v-list>
                                  <v-list v-if="orderData.acceptedPaymentMethods[0].paymentMethod === 'Credit'">
                                    <v-btn class="mb-3 blue--text" @click="routeToCardProcessing" block outlined>Add payment method</v-btn>
                                  </v-list>
                                </v-list>
                              </v-row>
                            </v-card-text>


                          </v-card>
<!--                          booking request and confirmation buttons-->
                          <v-card
                              class="mx-auto mb-2"
                              max-width="350"
                              flat
                              v-if="!convertableToBook"
                          >
                            <v-card-actions v-if="tab === 2" class="mt-6">
                              <v-btn block class="blue" v-if="!quoteRequestId"  dark @click="requestBookingConfirmation">

                                Request booking</v-btn>
                              <v-btn block text class="green--text" v-if="quoteRequestId">
                                <v-icon class="green--text">check_circle</v-icon>
                                 Request Successful</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>

              </v-tab-item>
            </v-tabs-items>
            <v-card-actions v-if="tab !== 2">
              <v-btn v-if="tab > 0" @click="backStep" text>Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn class="blue--text" outlined v-if="tab < 2" dark @click="nextStep">Next</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="itemDialog"
          max-width="500"
                persistent
      >
        <v-card  v-if="selectedItem">
          <v-card-title class="text-h5">
            {{selectedItem.title}}
            <v-spacer></v-spacer>
            <v-btn icon
                   @click="itemDialog = false"
            ><v-icon>clear</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <div class="ml-3 text-h6">${{calcLineItemCost(selectedItem)}}</div>
              <!--        remove line item-->
              <v-btn   @click="removeSelectedItemDialog = true"
                       class="red--text ml-3 mt-2"
                       x-small
                       rounded
                       outlined
                ><v-icon>close</v-icon>Remove</v-btn>
            </v-row>
            <div class="subtitle-1 mt-6 font-weight-bold">
              <div v-if="selectedItem.availableOnDemand" >
                <v-icon small class="success--text">fiber_manual_record</v-icon>Available</div>
              <div v-else><v-icon small class="warning--text">fiber_manual_record</v-icon>Needs confirmation</div>
            </div>
            <!--              addOn item qty-->
            <v-text-field
                v-if="selectedItem.itemType === 'product'"
                v-model="selectedItem.qty"
                label="Quantity"
                placeholder="1"
                min="1"
                type="number"
            >
            </v-text-field>

            <!--              locations-->
            <v-expansion-panels
                class="elevation-0 mt-8"
                v-model="expandLocations"
                multiple
            >
              <!--             additional locations-->
              <v-expansion-panel  v-if="selectedItem.locations">
                <v-expansion-panel-header class="grey lighten-4">
                  <div class="text-h6 font-weight-regular">Locations</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content >
                  <v-flex xs12 sm12 md12>
                    <!-- add more locations-->
                    <v-list v-for="location in selectedItem.locations" :key="location.created">
                      <!--lineItem Location-->
                        <div v-if="location.locationType !== 'startingLocation'" class="subtitle-2 font-weight-regular pb-3">
                          <v-icon >pin_drop</v-icon>
                          {{locationCountryRemoved(location.formatted_address)}}
                          <v-icon @click="removeLineItemLocation(location)"
                                  class="red--text">close</v-icon>
                        </div>
                    </v-list>
                    <div class="text-h6 pt-3 pb-2 font-weight-regular">Add location</div>
                    <v-flex xs10 sm6 md6>
                      <locations-autocomplete  @locationFound="addLineItemLocations"></locations-autocomplete>
                    </v-flex>
                    <v-divider class="mb-1"></v-divider>

                  </v-flex>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!--              add on items-->
            <v-expansion-panels
                v-model="selectedItemAddonsPanel"
                multiple
                v-if="selectedItem.addOnItems"
            >
              <v-expansion-panel
                  v-if="selectedItem.itemType === 'service'">
                <v-expansion-panel-header class="grey lighten-4">
                  <div class="text-h6 font-weight-regular">Included</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content >
                  <v-flex xs12 sm12 md12>
                    <v-simple-table fixed-header>
                      <template v-slot:default>
                        <tbody v-for="item in selectedItem.addOnItems"
                               :key="item.id">
                        <tr>
                            <td>{{item.qty}} x</td>
                          <td @click="modifyAddOnItem(item)">
                            {{item.title}}
                          </td>
                          <td class="text-right">
                            <!--remove addOn Item-->
                            <v-btn icon @click="removeAddOnItem(item.id)">
                              <v-icon class="red--text">clear</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <addon-item-picker
                        :publicListingId="publicListingId"
                        :listingId="listingId"
                        @itemFound="addOnItemPicked"
                    ></addon-item-picker>
                  </v-flex>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
<!--            lineItem description-->
            <v-expansion-panels
                v-if="selectedItem.fullDescription">
            <v-expansion-panel>
              <v-expansion-panel-header class="grey lighten-4">
                <div class="text-h6 font-weight-regular">More details</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content >
                <v-flex xs12 sm12 md12>
                  <!--            Short description-->
                  <v-card-subtitle>
                    <div class="body-1">{{selectedItem.shortDescription}}</div>
                  </v-card-subtitle>
                  <v-card-text>
                    <ul v-for="feature in selectedItem.featuresList" :key="feature.id">
                      <li class="body-1">{{feature.text}}</li>
                    </ul>
                  </v-card-text>
                  <!--full item description-->
                  <v-card-text>
                    <div class="body-1">{{selectedItem.fullDescription}}</div>
                  </v-card-text>
                  <!--featured images-->
                  <v-card-text v-for="img in selectedItem.featuredImgs" :key="img.id">
                    <v-img :src="img.url"></v-img>
                  </v-card-text>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>
            </v-expansion-panels>

          </v-card-text>
          <v-card-actions>
            <!--            remove selectedItem-->
<!--            <v-btn block outlined-->
<!--                   @click="removeSelectedItemDialog = true"-->
<!--            ><v-icon>clear</v-icon>remove Item</v-btn>-->
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                text
                @click="itemDialog = false"
            >
              close
            </v-btn>
            <v-btn
                text
                @click="updateSelectedItemItemQty"
                class="blue white--text"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="selectedAddOnItemDialog"
                persistent
                max-width="500"
      >
        <v-card v-if="selectedAddOnItem">
          <v-card-title class="text-h5">
            {{selectedAddOnItem.title}}
          </v-card-title>

          <v-card-text>
            <v-card-actions>
              <v-btn block outlined @click="selectedAddOnItem.qty++">
                <v-icon>add</v-icon></v-btn>
            </v-card-actions>
            <v-container fluid fill-height>
              <v-layout align-center justify-center>
                <v-flex xs3 sm3 md3 lg3>
                  <v-text-field
                      v-model="selectedAddOnItem.qty"
                      label="Quantity"
                      type="number"
                      dense
                      solo
                      placeholder="1"
                      min="1"
                      max="100"
                      class="display-1"
                      height="60px"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-btn block
                     outlined
                     :disabled="selectedAddOnItem.qty <= 1"
                     @click="selectedAddOnItem.qty--">
                <v-icon>remove</v-icon></v-btn>
            </v-card-actions>
            <v-card-actions class="mt-10">
              <v-spacer></v-spacer>
              <v-btn
                  text
                  @click="selectedAddOnItemDialog = false"
              >close</v-btn>
              <v-btn
                  color="blue"
                  outlined
                  @click="updateAddOnItem"
              >
                ok
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="changeLocationLabel"
                ref="dialog"
                max-width="500"
                persistent
      >
        <v-card v-if="selectedLocation">
          <v-card-title>
            <div class="headline font-weight-light">
              <v-icon class="red--text">pin_drop</v-icon>
              {{locationCountryRemoved(selectedLocation.formatted_address)}}
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-3">

            <v-text-field outlined v-model="selectedLocationLabel"
                          label="Apt, suit#"
                          placeholder="101"></v-text-field>

            <div class="subtitle-2 mb-3">Change stop order</div>

            <v-row>
              <v-card class="d-flex justify-center mb-6 elevation-0">
                <v-col>
                  <v-btn outlined
                         @click="moveLocationUp(selectedLocation.id)">
                    <v-icon class="black--text">arrow_upward</v-icon>
                    Move up
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn outlined
                         @click="moveLocationDown(selectedLocation.id)"
                  >
                    <v-icon class="black--text">arrow_downward</v-icon>
                    Move down
                  </v-btn>
                </v-col>
              </v-card>
            </v-row>
            <v-textarea outlined v-model="selectedLocation.note"
                          label="Note"
                          placeholder="Something important.."></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="dark" @click="changeLocationLabel = false" text>cancel</v-btn>
            <v-btn v-if="!loading"  class="blue--text" dark outlined @click="updateLocationLabel()">Save</v-btn>
            <app-loading v-else></app-loading>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="removeSelectedItemDialog"
                max-width="500"
      >
        <v-card v-if="selectedItem">
          <v-card-title class="text-h5">
            <v-icon class="warning--text">warning</v-icon>
            Remove
          </v-card-title>

          <v-card-text class="subtitle-1">
            {{selectedItem.title}} will be removed.
          </v-card-text>

          <v-card-actions>
            <v-btn
              block
              text
              @click="removeSelectedItemDialog = false"
            >
              cancel
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn
                color="red"
                block
                outlined
                @click="removeSelectedItem()"
            >
              delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>
<script>
import {onSnapshot, doc, collection, updateDoc, addDoc, getDoc} from "firebase/firestore";
import { v1 as uuidv1} from "uuid";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFunctions, httpsCallable  } from 'firebase/functions';
import { arrayMoveImmutable } from 'array-move'
import moment from "moment";

export default {
  components: {},
  props: ['quoteId' ,'publicListingId', 'listingId', 'itemId'],
  data: () => ({
    // mlItemDialog: false,
    item: null,
    tab: 0,
    tabItems: [
      'Time & Date', 'Location', 'Confirm'
    ],
    quoteData: null,
    // date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    // time: '12:00',
    date: null,
    time: null,
    selectedItem: null,
    itemDialog: false,
    addOnItems: null,
    changeLocationLabel: false,
    selectedLocation: null,
    selectedLocationLabel: '',
    selectedLocationId: '',
    quoteLoading: false,
    // mediaUrl: undefined,
    // annotatedImage: null,
    // annonObj: null,
    // detectedItems: null,
    // annotatedImages: null,
    expandLocations: [0],
    selectedItemAddonsPanel: [0],
    selectedAddOnItem: null,
    selectedAddOnItemDialog: false,
    removeSelectedItemDialog: false,
    quoteRequestId: null,
    depositConfig: undefined,
    listingData: null,
    orderData: null,
    emailCopied: false,
    balanceRemaining: 0
  }),
  computed: {
    user () {
      let user = this.$store.getters.user
      return user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    totalListCost () {
      let lineItems = this.quoteData.lineItems
      let cost = 0
      if (lineItems) {
        lineItems.forEach(item => {
          let lineItemsCost = this.calcLineItemCost(item)
          cost += +lineItemsCost
          // console.log(cost)
        })
      }
      let costRounded = Number(cost).toFixed(2)
      return costRounded
    },
    paymentStructure () {
     if (this.depositConfig) {
       let lineItems = this.quoteData.lineItems
       let listingPaymentStructure
       // console.log(this.depositConfig)
       // let listingPaymentStructure = {depositType: 'percentOfTotal', percentOfTotal: 0.1, depositTitle: 'Booking deposit'}
       // listingPaymentStructure = {depositType: 'fixedAmount', depositAmount: 50, depositTitle: 'Booking deposit'}
       if (this.depositConfig.depositType === 'notRequired') {
         listingPaymentStructure = {depositType: 'notRequired'}
       }
       if (this.depositConfig.depositType === 'fixedAmount') {
         listingPaymentStructure = {
           depositType: 'fixedAmount',
           depositAmount: this.depositConfig.depositAmount,
           depositTitle: this.depositConfig.depositTitle
         }
       }
       if (this.depositConfig.depositType === 'percentOfTotal') {
         // console.log('in percent of total')
         listingPaymentStructure = {
           depositType: 'percentOfTotal',
           percentOfTotal: this.depositConfig.percentOfTotal,
           depositTitle: this.depositConfig.depositTitle
         }
       }
       // console.log(listingPaymentStructure)
       let cost = 0
       let paymentObj = []
       let bookingPayments = []
       if (lineItems) {
         lineItems.forEach(item => {
           let lineItemsCost = this.calcLineItemCost(item)
           cost += +lineItemsCost
         })
       }
       let costRounded = Number(cost).toFixed(2)
       let remainingBalance = 0
       if (listingPaymentStructure) {
         let depositObj = {
           splitTitle: listingPaymentStructure.depositTitle,
           created: Date.now(),
           id: uuidv1()
         }
         let remainingBalanceObj = {
           splitTitle: 'Remaining balance',
           created: Date.now(),
           id: uuidv1()
         }
         if (listingPaymentStructure.depositType === 'fixedAmount') {
           depositObj.splitAmount = listingPaymentStructure.depositAmount
         }
         if (listingPaymentStructure.depositType === 'percentOfTotal') {
           let depositPercentage = listingPaymentStructure.percentOfTotal/100
           depositObj.splitAmount = Number(costRounded * depositPercentage).toFixed(2)
         }
         if (listingPaymentStructure.depositType !== 'notRequired') {
           paymentObj.push(depositObj)
           bookingPayments.push(depositObj)
           remainingBalance = costRounded - depositObj.splitAmount
           remainingBalanceObj.splitAmount = Number(remainingBalance).toFixed(2)
         } else {
           remainingBalanceObj.splitAmount = costRounded
         }
         this.setRemainingBalance(remainingBalanceObj.splitAmount)
         paymentObj.push(remainingBalanceObj)
       }
       let paymentsCombined = {
         combinedPayments: paymentObj,
         bookingPayments: bookingPayments
       }

       return paymentsCombined
     } else return null
    },
    convertableToBook () {
      let convertableToBook = true
      let lineItems = this.quoteData.lineItems
      if (lineItems) {
        lineItems.forEach(item => {
          // console.log(item.availableOnDemand)
          if (!item.availableOnDemand) {
            convertableToBook = false
          }
        })
      }
      return convertableToBook
    },
    transactionTime () {
      return (date) => {
        let timeStamp = moment(date).format('ddd, MMM Do YYYY, hh:mm A')
        return timeStamp
      }
    },
    momentDate () {
      return (date) => {
        let day = moment(date).format('dddd, LL')
        return day
      }
    },
    invoiceObj () {
      // console.log(this.orderData)
      let invoiceObj = {
        // logo: this.user.thumbnailMediaUrl,
        publicListingId: this.publicListingId,
        // listingName: null,
        invoiceTitle: this.orderData.locations[0].name,
        invoiceNumber: this.quoteId.slice(0, 8),
        dateCreated: this.momentDate(this.orderData.created),
        contactName: null,
        contactEmail: this.user.email,
        contactPhoneNumber: null,
        // companyName: this.contactCompanyName,
        contactAddress: null,
        dateOfService: null,
        locations: null,
        lineItems: null,
        totalCost: this.totalListCost,
        dueNow: this.orderData.paymentDueNow.splitAmount,
        dueNowObj: this.orderData.paymentDueNow,
        dueDate: null,
        userEmail: null,
        userPhoneNumber: null
      }
      if (this.orderData.fulfillmentInfo.time) {
        invoiceObj.time = this.orderData.fulfillmentInfo.time
      } else {
        invoiceObj.time = ''
      }
      if (this.orderData.fulfillmentInfo.date) {
        invoiceObj.dateOfService = this.orderData.fulfillmentInfo.date
        invoiceObj.dueDate = this.orderData.fulfillmentInfo.date
      } else {
        invoiceObj.dueDate = this.orderData.fulfillmentInfo.date
        invoiceObj.dateOfService = ''
      }
      if (this.orderData.clientInfo) {
        invoiceObj.contactPhoneNumber = this.orderData.clientInfo.phoneNumber
        if(this.orderData.clientInfo.meetupLocation) {
          invoiceObj.contactAddress = this.orderData.clientInfo.meetupLocation.formatted_address
        } else {
          invoiceObj.contactAddress = ''
        }
        invoiceObj.contactName = this.orderData.clientInfo.name
        invoiceObj.userPhoneNumber = this.orderData.clientInfo.connectedPhoneNumber
      }
      if (this.orderData.locations.length !== 0) {
        let locations = this.orderData.locations
        let labeledLocals = []
        locations.forEach(location => {
          let locName = {name: location.name}
          if (location.label) {
            locName = {name: location.label + ' ' + location.name}
          }
          labeledLocals.push(locName)
        })
        invoiceObj.locations = labeledLocals
      }
      if (this.orderData.lineItems.length !== 0) {
        let emailItems = []
        this.orderData.lineItems.forEach(item => {
          emailItems.push({
            title: item.title,
            totalPrice: item.totalPrice,
            unitPrice: item.unitPrice,
            qty: item.qty,
            note: item.note})
        })
        invoiceObj.lineItems = emailItems
      }
      invoiceObj.payments = this.orderData.payments
      invoiceObj.balanceRemaining = this.balanceRemaining
      invoiceObj.paymentMethods = this.paymentMethods
      if (this.orderData.acceptedPaymentMethods) {
        invoiceObj.paymentMethods = this.orderData.acceptedPaymentMethods
      }
      return invoiceObj
    }
  },
  mounted() {
    this.initCloudFunctions()
  },
  created () {
    // console.log(this.listingData)
    const auth = getAuth()
    // console.log(this.quoteId)
    let db = this.$store.state.db
    let listingRef = collection(db, 'publicListings',
        this.publicListingId
        + '/listings/' + this.listingId
        + '/addOnItems')
    onSnapshot(listingRef, res => {
      if (res && res.empty !== true) {
        let items = []
        res.forEach(item => {
          items.push(item.data())
        })
        this.addOnItems = items;
        // console.log(this.addOnItems)
      }
      this.$store.dispatch('setLoading', false)
    })
    // console.log(this.user)
    // console.log(this.quoteId)
    if (this.user) {
      // console.log('in created; loading quote data')
      let quoteRef = doc(db, 'customers', this.user.uid, 'quotes',  this.quoteId)
      onSnapshot(quoteRef, res => {
        let data = res.data()
        if (data) {
          // console.log(data)
          if(data.time) {
            this.time = data.time
           // console.log(data.time)
          }
          if(data.date) {
            this.date = data.date
            //console.log(data.date)
          }
          this.quoteData = data;

          if (!this.quoteData.locations) {
            if(this.quoteData.lineItems) {
              this.setQuoteLocations (data)
            }
          }
          if (this.quoteData.quoteRequestId) {
            this.quoteRequestId = this.quoteData.quoteRequestId
          } else {
            this.quoteRequestId = null
          }
          if (this.quoteData.updateLocations) {
            this.setQuoteLocations (data)
          }
          this.generateOrderData()
        }
        this.$store.dispatch('setLoading', false)
      })
    } else {
      onAuthStateChanged(auth, (user) => {
        //console.log(user)
        if(user) {
          // console.log(user)
          this.$store.dispatch('fetchUserData', user)
          this.loadQuoteData(user.uid)
        }
      })
    }
    let publicItemRef = doc(db, 'publicListings', this.publicListingId + '/listings/' + this.listingId)
    return getDoc(publicItemRef)
        .then(res => {
          if (res.exists()) {
            let data = res.data()
            this.listingData = data
            this.depositConfig = data.depositConfig
            this.$store.dispatch('setListingData', {...data, publicListingId: this.publicListingId, listingId: this.listingId})
            //console.log(this.listingDetails)
            this.generateOrderData()
          }
        })
  },
  methods: {
    // copyEmail () {
    //   navigator.clipboard.writeText(this.orderData.userEmail)
    //   this.emailCopied = true
    //   console.log('email copied')
    // },
    setRemainingBalance (value) {
      this.balanceRemaining = value
    },
    routeToCardProcessing () {
      // console.log("process webbooking")
      // console.log(this.orderData)
      // console.log(this.invoiceObj)
      let paymentObj = {
        invoiceObj: this.invoiceObj,
        orderData: this.orderData,
        invoiceId: this.quoteId,
        paymentInfo: this.orderData.paymentDueNow,
        transactionTime: this.transactionTime(Date.now()),
        notificationMethods: {
          email: true
        },
      }
      // console.log(paymentObj)
      this.$store.dispatch('initCardPayment', paymentObj)
      // path: '/checkSmsAuth/:publicListingId/:routeTo/:routeType/:orderId',
      return this.$router.push(
          '/webBookingDeposit/'
          + this.publicListingId + '/'
          + this.listingId + '/'
          + this.quoteId
      )
    },
    generateOrderData () {
      // console.log(this.listingData)
      if (this.quoteData) {
        let bookingTotal = 0
        let bookingData = {
          clientInfo: this.user,
          created: Date.now(),
          fulfillmentInfo: {
            date: this.quoteData.date,
            time: this.quoteData.time
          },
          id: this.quoteId,
          // items: this.quoteData.lineItems
        }
        if(this.listingData) {
          if (this.listingData.listingContactNumber) {
            bookingData.clientInfo.connectedPhoneNumber = this.listingData.listingContactNumber
          }
          if (this.listingData.acceptedPaymentMethods) {
            bookingData.acceptedPaymentMethods = this.listingData.acceptedPaymentMethods
          }
        }
        let sublineItem = []
        this.quoteData.lineItems.forEach(lineItem => {
          let lineItemBase = {
            ...lineItem,
            unitPrice: lineItem.baseRate,
            unitCost: lineItem.cost,
            totalPrice: Number(lineItem.qty * lineItem.baseRate).toFixed(2)
          }
          lineItemBase.qty = Number(lineItemBase.qty).toFixed(2)
          bookingTotal += +lineItemBase.totalPrice
          sublineItem.push(lineItemBase)
          for (let i = 0; i < lineItem.sublineItems.length; i++) {
            let obj = {...lineItem.sublineItems[i]}
            obj.unitPrice = Number(lineItem.sublineItems[i].cost)
            obj.qty = Number(lineItem.sublineItems[i].qty).toFixed(2)
            obj.parentItemId = lineItem.id
            obj.title = lineItem.sublineItems[i].title
            obj.totalPrice = Number(obj.unitPrice * obj.qty).toFixed(2)
            obj.note = ''
            bookingTotal += +obj.totalPrice
            sublineItem.push(obj)
          }
        })
        bookingData.items = sublineItem
        bookingData.lineItems = sublineItem
        bookingData.locations = this.quoteData.locations

        if (this.paymentStructure) {
          bookingData.paymentDueNow = this.paymentStructure.bookingPayments[0]
          bookingData.payments = this.paymentStructure.bookingPayments
        }

        // console.log(bookingTotal)
        // console.log('Starting log')
        // console.log(this.paymentStructure)

        bookingData.refListing = this.listingData
        bookingData.status = 'warning'
        bookingData.total = bookingTotal
        // console.log(bookingData)
        this.orderData = bookingData
      }
    },
    requestBookingConfirmation () {
      // console.log(this.quoteData)
      let db = this.$store.state.db
      let quoteRef = doc(db, 'customers', this.user.uid, 'quotes',  this.quoteId)
      let quoteUpdateRef = collection(db, 'customers', this.user.uid, 'quotes',  this.quoteId, 'updates')
      this.quoteData.status = 'clientSentUpdate'
      return addDoc(quoteUpdateRef, this.quoteData)
            .then(res => {
              this.quoteData.quoteRequestId = res.id
              return updateDoc(quoteRef, this.quoteData)
            })
          .catch(err => {
            this.store.dispatch('setError', err)
            console.log(err)
          })
    },
    // add more addOn items to selectedLineItem
    addOnItemPicked (item) {
      let newItem = {...item}
      newItem.qty = 1
      newItem.id = uuidv1()
      if (this.selectedItem.addOnItems) {
        this.selectedItem.addOnItems.push(newItem)
        return this.reCalculateSelectedLineItem ()
      } else {
        this.selectedItem.addOnItems = [{...newItem}]
        return this.reCalculateSelectedLineItem ()
      }
    },
    removeAddOnItem (addOnItemId) {
      // console.log(addOnItemId)
      let index = this.selectedItem.addOnItems.findIndex(addOn => {
        return addOn.id === addOnItemId
      })
      this.selectedItem.addOnItems.splice(index, 1)
      return this.reCalculateSelectedLineItem ()
    },
    updateAddOnItem () {
      // console.log(this.selectedAddOnItem)
      this.selectedAddOnItemDialog = false
      return this.reCalculateSelectedLineItem ()
    },
    modifyAddOnItem (selectedAddOnItem) {
      this.selectedAddOnItem = selectedAddOnItem
      this.selectedAddOnItemDialog= true
      // console.log(selectedAddOnItem)
    },
    customAddOnItem () {
      // // console.log(this.searchItem)
      // let newItem = {
      //   created: Date.now(),
      //   customItem: true,
      //   id: uuidv1(),
      //   imgs:[],
      //   instruction: '',
      //   kmPrice: 0,
      //   listed: false,
      //   minutePrice: 30,
      //   note: '',
      //   qty: 1,
      //   title: this.searchItem,
      //   unitPrice: 0
      // }
      // this.quoteData.addOnItems.push(newItem)
      // this.reCalculateItemCost()
      // this.updateQuote()
      // // console.log(newItem)
      // this.searchItem = ''

    },
    // selected quote line items methods
    openItemDialog (lineItem) {
      this.selectedItem = lineItem
      this.itemDialog = true
    },
    removeSelectedItem () {
      //console.log(this.selectedItem)
      let pickedItem = this.quoteData.lineItems.find(item => {
        return item.id === this.selectedItem.id
      })
      this.quoteData.updateLocations = true
      // console.log(pickedItem)
      let filteredIndex = this.quoteData.addOnItems.indexOf(pickedItem)
      this.quoteData.lineItems.splice(filteredIndex, 1)
      this.itemDialog = false
      this.removeSelectedItemDialog = false
      this.selectedItem = null
      this.updateQuote()
    },
    updateSelectedItemItemQty () {
      this.itemDialog = false
      this.reCalculateSelectedLineItem ()
    },
    addLineItemLocations (location) {
      // console.log(location)
      let locationObj = {...location}
      locationObj.created = Date.now()
      locationObj.itemId = this.selectedItem.id
      locationObj.locationType = 'additionalLocation'
      locationObj.id = uuidv1()
      this.selectedItem.locations.push(locationObj)
      // console.log(this.selectedItem.locations)
      // console.log(locationObj)
      return this.reCalculateLineItemLocationFactors()
    },
    removeLineItemLocation (location) {
      let index = this.selectedItem.locations.findIndex(local => {
        return local.id === location.id
      })
      this.selectedItem.locations.splice(index, 1)
      this.reCalculateLineItemLocationFactors()
    },
    reCalculateLineItemLocationFactors () {
      this.tab = 1
      this.quoteData.updateLocations = true
      let quoteLineItem = this.quoteData.lineItems.find(lineItem => {
        return lineItem.id === this.selectedItem.id
      })
      let quoteLineItemIndex = this.quoteData.lineItems.indexOf(quoteLineItem)
      let itemData = this.quoteData.lineItems[quoteLineItemIndex]

      let locations = itemData.locations
      // console.log(locations)
      if (locations.length > 1) {
        const functions = getFunctions()
        const getTravelTimeAndDistance = httpsCallable(functions, 'getTravelTimeAndDistance')
        return getTravelTimeAndDistance(itemData)
            .then(res => {
              this.selectedItem.travelTimeAndDistance = res.data.travelTimeAndDistance
              // console.log(res.data.travelTimeAndDistance)
              return this.reCalculateSelectedLineItem ()
            })
            .catch(err => {
              console.log(err)
            })
      } else {
        //make sure to update addOnItems in quoteData
        this.updateLineItem()
        this.selectedItem.travelTimeAndDistance = null
      }

    },
    reCalculateSelectedLineItem () {
      // console.log(this.selectedItem)
      let total = 0
      let totalHours = 0
      let totalKm = 0
      let item = this.selectedItem
      let lineItems = []
      let totalTravelHours = 0
      item.cost = Number(item.baseRate)
      if(item.itemType === 'service') {
        // console.log('service')
        total = Number(item.baseRate)
        // distance related costs
        if (this.selectedItem.locations.length > 1) {
          // console.log('serviceWithTravelTime calculated')
          if (this.selectedItem.travelTimeAndDistance) {
            totalKm = this.selectedItem.travelTimeAndDistance.meters/1000
            totalTravelHours = this.selectedItem.travelTimeAndDistance.seconds/3600
            //calculate additional km cost
            let distanceLineItem = {
              title: 'Distance Cost',
              created: Date.now(),
              cost: 0,
              qtyUnit: 'km',
              qty: 0,
              totalKm: totalKm,
              id: uuidv1()
            }
            if (totalKm > item.includedKm) {
              let additionalKm = totalKm - item.includedKm
              let additionalDistanceCost = additionalKm * +item.additionalKmRate
              distanceLineItem.qty = additionalKm
              distanceLineItem.cost = item.additionalKmRate
              total = total + additionalDistanceCost
            }
            if (distanceLineItem.cost > 0) {
              lineItems.push(distanceLineItem)
            }
            totalHours += totalTravelHours
          }
        }
        // addon items time factor
        let additionalTimelLineItem = {
          title: 'Additional Time',
          created: Date.now(),
          cost: 0,
          qty: 0,
          qtyUnit: 'hour',
          id: uuidv1()
        }
        let addOnItemTime = 0
        if (this.selectedItem.addOnItems.length !== 0) {
          this.selectedItem.addOnItems.forEach(addon => {
            return addOnItemTime += addon.qty * addon.timeFactor
          })
        }
        let extraAddonTime = (addOnItemTime/60) - (item.includedHours - totalTravelHours)
        if (extraAddonTime > 0) {
          //let extraAddOnCost = extraAddonTime * item.costPerAdditionalUnit
          additionalTimelLineItem.qty = Number(extraAddonTime).toFixed(2)
          additionalTimelLineItem.cost = Number(item.costPerAdditionalUnit).toFixed(2)
          lineItems.push(additionalTimelLineItem)
        }
        // console.log(+addOnItemTime/60)
        totalHours += +addOnItemTime/60
      }
      // product total calculations
      if(item.itemType === 'product') {
        // console.log('product')
        if (item.qty > 1) {
          total = item.baseRate + (item.qty - 1) * item.costPerAdditionalUnit
        } else {
          total = item.baseRate
        }
        // console.log(total)
        if (this.selectedItem.locations.length > 1){
          //distance calculations
          if (this.selectedItem.travelTimeAndDistance) {
            totalKm = this.selectedItem.travelTimeAndDistance.meters/1000
            totalTravelHours = this.selectedItem.travelTimeAndDistance.seconds/3600
            //calculate additional km cost
            let distanceLineItem = {
              title: 'Distance Cost',
              created: Date.now(),
              cost: 0,
              qty: 0,
              qtyUnit: 'km',
              totalKm: totalKm,
              id: uuidv1()
            }
            if (totalKm > item.includedKm) {
              let additionalKm = totalKm - item.includedKm
              let additionalDistanceCost = additionalKm * +item.additionalKmRate
              distanceLineItem.qty = additionalKm
              distanceLineItem.cost = +item.additionalKmRate
              total = total + additionalDistanceCost
            }
            if (distanceLineItem.cost > 0) {
              lineItems.push(distanceLineItem)
            }
            totalHours += totalTravelHours
          }
        }
      }
      //calculate additional hours cost
      if (totalHours > item.includedHours) {
        let additionalTime = totalHours - item.includedHours
        let additionalTimeCost = additionalTime * +item.costPerAdditionalUnit
        total += additionalTimeCost
      }
      let finalCost = total * item.additionalTimeFactor
      if (item.additionalCost) {
        item.additionalCost.forEach(cost => {
          lineItems.push(cost)
          return finalCost += cost.cost
        })
      }
      // let totalEstimate = Number(finalCost).toFixed(2)
      this.selectedItem.sublineItems = lineItems
      this.updateLineItem()
      // console.log('Distance: '+ totalKm)
      // console.log('Time: '+ totalHours)
      // console.log('Cost: '+ totalEstimate)
    },
    updateLineItem () {
      let quoteLineItem = this.quoteData.lineItems.find(lineItem => {
        return lineItem.id === this.selectedItem.id
      })
      let quoteLineItemIndex = this.quoteData.lineItems.indexOf(quoteLineItem)
      this.quoteData.lineItems[quoteLineItemIndex] = this.selectedItem
      this.updateQuote()
    },
    calcLineItemCost (item) {
      // console.log(item)
      let cost = Number(item.cost)
      if (item.qty > 1) {
        cost = Number(item.baseRate) + (item.qty - 1) * item.costPerAdditionalUnit
      } else {
        cost = Number(item.baseRate)
      }
      if (item.sublineItems) {
        item.sublineItems.forEach(subItem => {
          // console.log(subItem)
          cost += Number(subItem.cost)* Number(subItem.qty)
        })
      }
      // console.log(cost)
      let costRounded = Number(cost).toFixed(2)
      return costRounded
    },
    setQuoteLocations (data) {
      let lineItems = data.lineItems
      let sortedLocations = []
      let lineItemArrays = []
      for (let i = 0; i < lineItems.length; i++) {
        let itemLocations = lineItems[i].locations
        if (itemLocations.length !== 0) {
          lineItemArrays.push(lineItems[i].locations)
        }
      }
      let locations = [].concat(...lineItemArrays)
      for (let j = 0; j < locations.length; j++) {
        if (locations[j].locationType !== 'startingLocation') {
          let obj = {...locations[j]}
          sortedLocations.push(obj)
        }
      }
      // console.log(sortedLocations)
      console.log('set locations triggered')
      this.quoteData.locations = sortedLocations
      this.quoteData.updateLocations = false
      this.updateQuote()
    },
    locationCountryRemoved (location) {
      // console.log(location)
      // let formattedLocation = location
      let formattedLocation = location.match(/^(?:[^,]*,){2}([^,]*)/)[0]
      return formattedLocation
    },
    routeToSmsAuth () {
      this.$router.push('/smsAuth/' + this.user.uid
          + '/' + this.publicListingId
          + '/' + this.listingId
          + '/' + this.itemType
          + '/' + this.itemId
          + '/' + this.quoteId)
    },
    openMlDialog() {
      // this.mlItemDialog = true
    },
    removeImageLink() {
      // this.mediaUrl = undefined
    },
    addImageLink(link) {
      // // console.log(link)
      // let detectedItems = []
      // this.$store.dispatch('setLoading', true)
      // this.mediaUrl = link.url
      // const functions = getFunctions()
      // const annotateImage = httpsCallable(functions, 'annotateImageToItems')
      // // console.log(this.addOnItems)
      //
      // annotateImage({fileName: link.imgLocation})
      //     .then(res => {
      //       if (res.data) {
      //         return res.data.annotatedImage
      //       }
      //     })
      //     .then(annotatedImages => {
      //       // console.log(annotatedImages)
      //       if (annotatedImages) {
      //         let objects = annotatedImages.objects
      //         // console.log(objects)
      //         if (this.addOnItems) {
      //           // console.log(this.addOnItems)
      //           let items = this.addOnItems
      //           objects.forEach(object => {
      //             let matchedItem = items.find(item => {
      //               return object.name === item.title
      //             })
      //             if (matchedItem) {
      //               let mlObject = matchedItem
      //               mlObject.mlObject = true
      //               mlObject.normalizedVerticies = object.boundingPoly.normalizedVertices
      //               mlObject.score = object.score
      //               mlObject.imgs = [{id: link.id, url: link.url}]
      //               mlObject.qty = 1
      //               detectedItems.push(mlObject)
      //             } else {
      //               let item = {
      //                 created: Date.now(),
      //                 customItem: false,
      //                 id: object.mid,
      //                 mlObject: true,
      //                 normalizedVerticies: object.boundingPoly.normalizedVertices,
      //                 score: object.score,
      //                 imgs:[{id: link.id, url: link.url}],
      //                 instruction: '',
      //                 kmPrice: 0,
      //                 listed: false,
      //                 minutePrice: 30,
      //                 note: '',
      //                 qty: 1,
      //                 title: object.name,
      //                 unitPrice: 0
      //               }
      //               detectedItems.push(item)
      //             }
      //           })
      //           return detectedItems
      //           //console.log(detectedItems)
      //         }
      //       }
      //     })
      //     .then(detectedItems => {
      //       if (detectedItems) {
      //         let mlItems = []
      //         detectedItems.forEach(item => {
      //           return mlItems.push({
      //             ...item,
      //             selected: true
      //           })
      //         })
      //         // console.log(mlItems)
      //         return this.detectedItems = mlItems
      //       } else {
      //         return this.$store.dispatch('setError', {message: "Auto detection failed. Let's try again"})
      //       }
      //     })
      //     .then(() => {
      //       return this.$store.dispatch('setLoading', false)
      //     })
      //     .catch(err => {
      //       console.log(err)
      //       this.$store.dispatch('setLoading', false)
      //       this.$store.dispatch('setError', err)
      //     })
    },
    addNewItems () {
      // let newItems = []
      // this.detectedItems.forEach(item => {
      //   if (item.selected) {
      //     newItems.push(item)
      //   }
      // })
      // if(newItems.length !== 0) {
      //   newItems.forEach(item => {
      //     item.id = uuidv1()
      //
      //     this.quoteData.addOnItems.push(item)
      //   })
      //   this.quoteLoading = false
      //   this.reCalculateItemCost()
      //   this.updateQuote()
      // }
      // this.mlItemDialog = false
    },
    loadQuoteData (userUid) {
      // console.log(this.user)
      let db = this.$store.state.db
      let quoteRef = doc(db, 'customers', userUid, 'quotes',  this.quoteId)
      onSnapshot(quoteRef, res => {
        let data = res.data()
        if (data) {

          // console.log(data)
          if(data.time) {
            this.time = data.time
          }
          if(data.date) {
            this.date = data.date
          }
          this.quoteData = data;
          if (!this.quoteData.locations) {
            if(this.quoteData.lineItems) {
              this.setQuoteLocations (data)
            }
          }
          if (this.quoteData.quoteRequestId) {
            this.quoteRequestId = this.quoteData.quoteRequestId
          } else {
            this.quoteRequestId = null
          }
          if (this.quoteData.updateLocations) {
            this.setQuoteLocations (data)
          }
          this.generateOrderData()
        }
        this.$store.dispatch('setLoading', false)
      })
    },
    initCloudFunctions () {
      console.log('fetch locations api to boot from cold start')
    },
    // location tab methods
    moveLocationDown (locationId) {
      let movedLocation = this.quoteData.locations.find((location) => {
        return location.id === locationId
      })
      let index = this.quoteData.locations.indexOf(movedLocation)
      this.quoteData.locations = arrayMoveImmutable(this.quoteData.locations, index, index+1)
      this.changeLocationLabel = false
      this.updateQuote()
    },
    moveLocationUp (locationId) {
      // console.log(locationId)
      let movedLocation = this.quoteData.locations.find((location) => {
        return location.id === locationId
      })
      let index = this.quoteData.locations.indexOf(movedLocation)
      this.quoteData.locations = arrayMoveImmutable(this.quoteData.locations, index, index - 1)
      this.changeLocationLabel = false
      this.updateQuote()
    },
    changeLabel (locationId) {
      let movedLocation = this.quoteData.locations.find((location) => {
        return location.id === locationId
      })
      let index = this.quoteData.locations.indexOf(movedLocation)
      this.changeLocationLabel = true
      this.selectedLocationLabel = this.quoteData.locations[index].label
      this.selectedLocationId = locationId
      this.selectedLocation = this.quoteData.locations[index]
    },
    updateLocationLabel () {
      let changedLocation = this.quoteData.locations.find((location) => {
        return location.id === this.selectedLocationId
      })
      let index = this.quoteData.locations.indexOf(changedLocation)
      if (this.selectedLocationLabel) {
        this.quoteData.locations[index].label = this.selectedLocationLabel
      }
      if (this.selectedLocation.note) {
        this.quoteData.locations[index].note = this.selectedLocation.note
      }
      let lineItems = this.quoteData.lineItems
      if (lineItems) {
        let updateLineItem = lineItems.find(item => {
          return item.id === this.selectedLocation.itemId
        })
        let itemIndex = lineItems.indexOf(updateLineItem)
        let lineItemLocation = this.quoteData.lineItems[itemIndex].locations.find((location) => {
          return location.id === this.selectedLocationId
        })
        let locationIndex = this.quoteData.lineItems[itemIndex].locations.indexOf(lineItemLocation)
        this.quoteData.lineItems[itemIndex].locations[locationIndex] = this.selectedLocation
        this.updateQuote()
      }
      this.changeLocationLabel = false
    },
    removeLocation (locationId) {
      let changedLocation = this.quoteData.locations.find((location) => {
        return location.id === locationId
      })
      let locationIndex = this.quoteData.locations.indexOf(changedLocation)
      let lineItemId = this.quoteData.locations[locationIndex].itemId
      let lineItem = this.quoteData.lineItems.find(item => {
        return item.id === lineItemId
      })
      this.openItemDialog (lineItem)
      this.expandLocations = [0]
      this.selectedItemAddonsPanel = []

    },
    // tab buttons
    nextStep () {
      console.log(this.tab)
      if (this.tab !== 3) {
        this.tab++
      }
      if (this.tab === 3) {
        console.log('route to invoice')
        // return this.routeToSmsAuth()
      }
    },
    backStep () {
      if (this.tab !== 0) {
        this.tab--
      }
    },
    datePicked (date) {
      this.quoteData.date = date
      this.updateQuote()
    },
    timePicked (time) {
      this.quoteData.time = time
      this.updateQuote()
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    updateQuote () {
      // console.log('quoteUpdated')
      let db = this.$store.state.db
      this.quoteData.quoteRequestId = null
      this.quoteData.status = 'quoteUpdated'
      // console.log( this.quoteData.quoteRequestId)
      let quoteRef = doc(db, 'customers', this.user.uid, 'quotes',  this.quoteId)
      updateDoc(quoteRef, this.quoteData)
      this.generateOrderData()
    }
  }

}
</script>
